
import { Input } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
const { TextArea } = Input;

export const RemarkAuxi = () => {
    const { eng_log_basic_id } = useParams();
  const [freeText, setFreeText] = useState("");
  const [submitStatus, setSubmitStatus] = useState(true);
  useEffect(() => {
    AUXI_REMARKS_DETAILS();
  }, []);
  
  const AUXI_REMARKS_DETAILS = async () => {
    const formData = new FormData();
    formData.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
    try {
      const res = await post(ApiURL.get_auxi_remarks_details_com, formData);
      if (res?.status === true && res?.response_data) {
        setFreeText(res?.response_data?.auxi_remark || "");
     
      }
    } catch (err) {
      // Optional error toast
    }
  
  };

  return (
    <div className="white-container">
      <div className="row">
        <div className="col-12">
          <div className="input-box">
            <label>Auxiliary Machinery Remarks</label>
            <TextArea
              rows={6}
              placeholder="Auxiliary Machinery comments"
              maxLength={1000}
              disabled={submitStatus}
              value={freeText}
              onChange={(e) => setFreeText(e.target.value)}
            />
            
          </div>
        </div>
      </div>

    </div>
  );
}

